import { render, staticRenderFns } from "./UploadRemittancePage.vue?vue&type=template&id=34bc3b32&scoped=true"
import script from "./UploadRemittancePage.vue?vue&type=script&lang=js"
export * from "./UploadRemittancePage.vue?vue&type=script&lang=js"
import style0 from "./UploadRemittancePage.vue?vue&type=style&index=0&id=34bc3b32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bc3b32",
  null
  
)

export default component.exports